module.exports = __webpack_public_path__ + "static/media/B9BFFB06-BA49-453D-8345-53D6A4518643-min.830e7882.jpg";